export const LoggingConstants = {
    DYNAMIC_DELIVERY: "DD-"
} as const;